import React from 'react';

import type { ContentImageEntry } from 'api/contentful/contentTypes.cloverdotcom';
import { Image, IImageProps } from 'components/Image/Image';

interface IContentImageProps extends Omit<IImageProps, 'src' | 'dataAssetId'> {
  entry?: ContentImageEntry;
}

export const ContentImage = React.forwardRef<HTMLImageElement, IContentImageProps>(
  ({ entry, alt, ...props }, ref) => {
    if (!entry) return null;
    const { file: { url } = {}, id } = entry;
    if (!url) return null;

    return (
      <Image src={url} alt={alt !== undefined ? alt : entry.title} dataAssetId={id} ref={ref} {...props} />
    );
  },
);

ContentImage.displayName = 'ContentImage';
